import React from 'react';
import { connect } from 'react-redux';

import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import NewCardField from 'apps/auth/components/form/NewCardField';
import Form from 'apps/auth/components/form-multi/Form';
import BasePage from 'apps/auth/components/utils/BasePage';
import { CARD_CVV, CARD_EXP_DATE, PAN } from 'apps/auth/constants/fieldsName';
import { ADD_SOURCE_BANK_CARD, TOP_UP_ACCOUNT } from 'apps/auth/constants/formName';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { isObject } from 'apps/auth/helpers/utils';

const TopUpByCardPage = (props) => {
    const submitHandler = (_fields, data) => {
        if (Object.keys(data.errors).length === 0) {
            logInfo(data);
        }
    };

    const addField = (fieldName) => {
        if (
            fieldName === props.card.pan.name ||
            (props.card.cardExpired && fieldName === props.card.cardExpired.name) ||
            (props.card.cvv && fieldName === props.card.cvv.name)
        ) {
            return false;
        }
        return true;
    };

    return (
        <CommonPage backUrl={`/auth/ga/pocket/${props.id}/top-up`} leftCloseIcon hasBottomPanel>
            <HeaderPanel title={props.accountHolder} subtitle={props.accountHolder} />
            <Form
                formName={TOP_UP_ACCOUNT}
                getCanonicalPath={true}
                fields={props.fields}
                onSubmitHandler={submitHandler}
                action={`/auth/ga/pocket/${props.id}/card/add.acton`}
            >
                <NewCardField
                    binExtraName="binInfo"
                    formName={TOP_UP_ACCOUNT}
                    panName={PAN}
                    redirectByBinUrl={false}
                    expiredDateName={CARD_EXP_DATE}
                    countryA2To={props.countryA2To}
                    countryA2From={props.countryA2From}
                    cvvName={CARD_CVV}
                />
                {isObject(props.fields) && (
                    <Row indent="24px">
                        {Object.values(props.fields).map((field) => {
                            if (addField(field.name)) {
                                return <InputAutoDetect key={field.name} formName={ADD_SOURCE_BANK_CARD} field={field} />;
                            } else {
                                return false;
                            }
                        })}
                    </Row>
                )}

                <FixedBottomPanel isRightAligned>
                    <Button type="submit" raised={true} caption={props.cardsAddBankCardButton} />
                </FixedBottomPanel>
            </Form>
        </CommonPage>
    );
};

const mapStateToProps = (state) => {
    return {
        fields: state.form[TOP_UP_ACCOUNT].fields,
        card: state.extra.card,
        countryA2From: state.extra.countryA2From,
        countryA2To: state.extra.countryA2To,
        id: state.extra.id,
        title: state.messages.pageMessages.title,
        accountHolder: state.messages.pageMessages.accountHolder,
        cardsAddBankCardButton: state.messages.pageMessages.cardsAddBankCardButton,
    };
};

export default connect(mapStateToProps, null)(BasePage(TopUpByCardPage));
